import { getIsSeller } from '@app/ducks';
import { getPricelists } from '@app/services/pricelistRepository';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  refetchOnMount?: boolean;
}

export const usePricelists = ({ refetchOnMount = true }: Props = {}) => {
  const { t } = useTranslation(['genericErrors']);
  const isSeller = useSelector(getIsSeller);

  return useQuery({
    enabled: isSeller,
    meta: {
      errorMessage: t('genericErrors:fetch_pricelists_fail'),
    },
    queryFn: getPricelists,
    queryKey: ['pricelists'],
    refetchOnMount,
  });
};
